'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Icon = styled__default.i(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    ", "\n"], ["\n    font-size: ", ";\n    color: ", ";\n    ",
    "\n"])), function (_a) {
    var size = _a.size;
    return size + "px";
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return color || theme.colors.greys.adminGreyDark;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n      opacity: .5;\n      cursor: not-allowed;\n    ";
});
var FaIcon = function (_a) {
    var dataTestId = _a.dataTestId, className = _a.className, _b = _a.size, size = _b === void 0 ? 24 : _b, disabled = _a.disabled, color = _a.color, rest = tslib_es6.__rest(_a, ["dataTestId", "className", "size", "disabled", "color"]);
    return (React__default.createElement(Icon, tslib_es6.__assign({ className: className, size: size, color: color, disabled: disabled, "data-testid": dataTestId ? dataTestId + "-fa-icon" : 'fa-icon' }, rest)));
};
var templateObject_1;

exports.FaIcon = FaIcon;
